import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';

export function StepButton({ step, onClick }) {
  return (
    <button
      type="button"
      className="flex items-center self-start gap-1.5 text-sm font-medium text-midnight-700 mb-2 hover:opacity-50"
      onClick={onClick}
    >
      {step > 1 && <ArrowLongLeftIcon aria-hidden="true" className="size-6" />}
      Step {step} of 4
    </button>
  );
}
